import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { PhoneFilterOptions } from '@app/akita/api/products/models/phone-filter-options.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { PhoneFiltersOverlayDynamicService } from '@app/overlays/phone-filters-overlay/services/phone-filters-overlay-dynamic.service';
import { BehaviorSubject, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { PopsySkeletonComponent } from '../../skeleton/popsy-skeleton.component';
import { ArrowUp1IconComponent } from '../../../shared/components/icons/generated/arrow-up-1/arrow-up-1.component';
import { ArrowDown1IconComponent } from '../../../shared/components/icons/generated/arrow-down-1/arrow-down-1.component';
import { AlignRightIconComponent } from '../../../shared/components/icons/generated/align-right/align-right.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'popsy-filter-by-phone-filters',
  templateUrl: './filter-by-phone-filters.template.html',
  styleUrls: ['./filter-by-phone-filters.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    NgIf,
    AlignRightIconComponent,
    ArrowDown1IconComponent,
    ArrowUp1IconComponent,
    PopsySkeletonComponent,
    AsyncPipe,
  ],
})
export class FilterByPhoneFiltersComponent implements OnDestroy {
  @Input() public value?: PhoneFilterOptions | null;
  @Input() public loading?: boolean | null;
  @Input() public compact?: boolean | null;

  @Output() public readonly phoneFiltersChanged: EventEmitter<PhoneFilterOptions>;

  private readonly openSubject: BehaviorSubject<boolean>;
  public readonly open$: Observable<boolean>;

  private readonly destroySubject: Subject<void>;

  private sortFilterOverlaySubscription?: Subscription | null;

  constructor(
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly phoneFiltersOverlayDynamicService: PhoneFiltersOverlayDynamicService
  ) {
    this.destroySubject = new Subject();
    this.phoneFiltersChanged = new EventEmitter();

    this.openSubject = new BehaviorSubject(false as any);
    this.open$ = this.openSubject.asObservable();
  }

  public onOpenFilterByPhoneFilterss(): boolean {
    if (this.sortFilterOverlaySubscription) {
      this.sortFilterOverlaySubscription.unsubscribe();
    }

    this.sortFilterOverlaySubscription = this.phoneFiltersOverlayDynamicService.observe
      .pipe(takeUntil(this.destroySubject))
      .subscribe({
        next: (data?: any | null) => {
          const isOpen = Boolean(data);
          this.openSubject.next(isOpen);

          if (!isOpen) {
            const phoneFilters =
              this.phoneFiltersOverlayDynamicService.phoneFilters || null;
            if (phoneFilters) {
              this.phoneFiltersChanged.emit(phoneFilters);
            }
          }
        },
      });

    this.phoneFiltersOverlayDynamicService.open({
      data: {
        phoneFilters: this.value,
      },
      isBrowser: this.akitaRouterQuery.isBrowser,
    });

    return false;
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();

    if (this.sortFilterOverlaySubscription) {
      this.sortFilterOverlaySubscription.unsubscribe();
    }
  }
}
